import {
  DELETE_ANSWERED_CALL,
  UPDATE_CALLS_STATUS,
  CREATE_SERVICE,
  CREATED_SERVICE,
  CHECK_CALLS_STATUS,
  HOLD,
  HANG_UP,
} from "@/events/constants";

import ApiPbxClient from "@/api/ApiPbxClient";
import { COMPLETING } from "@/store/modules/pbx/calls";

const store = window.store;

const handleUpdateCallsStatus = (payload) => {
  store.dispatch("pbxCalls/updateCallsStatus", payload);
};

const handleDeleteAnsweredCall = ({ asteriskId }) => {
  store.dispatch("app/deleteAnsweredCall", asteriskId);
};

const handleCreateService = () => {
  store.dispatch("pbxCalls/setOnCallStage", COMPLETING);
};

const handleHangUp = async ({ asteriskId, tripId }) => {
  const data = {
    servIds: tripId ? [tripId] : null,
  };

  const params = {
    asteriskId: asteriskId,
    phoneExt: store.getters["clientUserRegisterData/phoneExt"],
  };

  try {
    await new ApiPbxClient().put("/calls/hangup", data, { params });
    await store.dispatch("pbxCalls/setIsOnCall", false);
    window.$bus.emit(CHECK_CALLS_STATUS);
  } catch (err) {
    // We want to free the phone even if the response is an error
    await store.dispatch("pbxCalls/setIsOnCall", false);
    console.error(err);
  }
};

const handleHold = async ({ asteriskId }) => {
  const params = {
    asteriskId,
    phoneExt: store.getters["clientUserRegisterData/phoneExt"],
  };

  try {
    await new ApiPbxClient().put("/calls/hold", null, { params });
    window.$bus.emit(CHECK_CALLS_STATUS);
    window.$bus.emit(DELETE_ANSWERED_CALL, { asteriskId });
  } catch (err) {
    console.error(err);
  }
};

const handleCreatedService = async ({ phoneAction, payload, serviceId }) => {
  const callId = payload.data.callId;
  if (!callId) return;

  switch (phoneAction) {
    case HANG_UP:
      await handleHangUp({ asteriskId: callId, tripId: serviceId });
      break;
    case HOLD:
      await handleHold({ asteriskId: callId, tripId: serviceId });
      break;
  }
};

export default {
  async handle(event, payload) {
    switch (event) {
      case UPDATE_CALLS_STATUS:
        handleUpdateCallsStatus(payload);
        break;
      case DELETE_ANSWERED_CALL:
        handleDeleteAnsweredCall(payload);
        break;
      case CREATE_SERVICE:
        handleCreateService(payload);
        break;
      case CREATED_SERVICE:
        await handleCreatedService(payload);
        break;
      case HANG_UP:
        await handleHangUp(payload);
        break;
    }
  },
};
